import React from 'react';
import { motion } from 'framer-motion';
import { Icon } from '@chargify/icons';
import { arrowMotion } from '../../constants';
import { IconWrapper } from './DropdownIcon.styles';

export type Props = {
  /**
   * Determines whether the expanded icon should appear
   */
  isExpanded: boolean;
  /**
   * Icon size
   */
  size: number;
  /**
   * Icon click event handler
   */
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
  /**
   * Icon color
   */
  iconColor?: string;
};

const DropdownIcon = ({ isExpanded, size, onClick, iconColor }: Props) => (
  <IconWrapper onClick={onClick} data-testid="select-icon">
    <motion.div
      initial={false}
      animate={isExpanded ? arrowMotion.expanded : arrowMotion.notExpanded}
    >
      <Icon fill={iconColor} size={size} type="chevronDown" />
    </motion.div>
  </IconWrapper>
);

export default DropdownIcon;
